export default {
    socialNetworks: [
        { id: "instagram", url: "https://www.instagram.com/profiler_games?igsh=MWY1NzVmYmo1dTI2bQ==" }
    ],
    amazon: "https://www.amazon.fr",
    website: "https://dossierscriminels.com/",
    showSubscribeForLocales: [
        "fr"
    ]
}